import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueConfigManager from 'vue-config-manager'
import VueAnalytics from 'vue-analytics'
import { sync } from 'vuex-router-sync' // handily adds router state to store state if you're into that kind of thing ( READ ONLY )
// import io from 'socket.io-client'
// import VueSocketio from 'vue-socket.io'

import App from './App.vue'
import store from './store'
import router from './router'
import config from './config/global'
// import { _CONNECT } from './external/request'

Vue.config.productionTip = false
Vue.use(VueConfigManager, ...config)
Vue.use(VueAnalytics, { id: 'UA-101754345-4', router })

// eslint-disable-next-line
const unsync = sync(store, router)
// unsync() function. Unsyncs store from router

// _CONNECT('GET', (d) => {
//   Vue.use(
//     VueSocketio,
//     config.defaults.socket.host + '?' + config.defaults.socket.tokenName + '=' + JSON.parse(d).token,
//     store)
// })

/* eslint-disable no-new */
new Vue({
  methods: {
    ...mapActions([
      'getContentTypes',
      'getEntries',
      'getEntry',
      'getAsset',
      'getLinkedEntries',
      'updateAppRootData',
      'updateAppData',
      'updatePages',
      'getContentType'
    ])
  },
  computed: {
    ...mapGetters([
      'domain',
      'currentLocale'
    ])
  },
  created: function () {
    let vue = this
    // TODO: detect locale and get appropriate content

    // Get the domain root data, then get the root website data associated with that domain, and in turn all page data (and links) for the website
    vue.getEntry(vue.domain)
      .then((d) => { vue.updateAppRootData(d); return d })
      .then((d) => {
        // if store locale is null (i.e not manually set), get locale from navigator
        // supported locales for digimaster are en-US and nl-NL
        const loc = vue.currentLocale || navigator.language !== 'nl-NL' ? 'en-US' : 'nl-NL'

        vue.getLinkedEntries({id: d.fields.website.sys.id, update: 'app', locale: loc})
        vue.updateAppRootData(d)

        vue.getContentType({contentType: 'product', type: 'Courses'}) // type is case sensitive...
      })
    // vue.getEntry(vue.domain)
    //   .then(function (d) { vue.updateAppRootData(d); return d })
    //   .then(function (d) {
    //     console.log('Getting app data')
    //     vue.getEntry(d.fields.website.sys.id)
    //       .then(function (d) { vue.updateAppData(d); return d })
    //       .then(function (d) { vue.updatePages(d.fields.pages) })
    //   })
  },
  sockets: {},
  router,
  store,
  components: { App },
  template: '<App />'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js